import {User} from "types/User";
import {dateTime} from "services/date";
import deserializeLinkedAccount from "./linked-account";

/**
 * Transform the given user by deserializing object properties
 *
 * @internal
 * @param user
 */
export default function deserializeUser(user: any): User {
    user.birthdate = dateTime(user.birthdate)
    user.claimed_at = dateTime(user.claimed_at)
    user.subscribed_at = dateTime(user.subscribed_at)
    user.first_logged_in_at = dateTime(user.first_logged_in_at)
    user.last_logged_in_at = dateTime(user.last_logged_in_at)
    user.created_at = dateTime(user.created_at)
    user.updated_at = dateTime(user.updated_at)

    user.linked_accounts = user.linked_accounts?.map(deserializeLinkedAccount)

    return user;
}